import { render, staticRenderFns } from "./recentList.vue?vue&type=template&id=6a3b5095&scoped=true"
import script from "./recentList.vue?vue&type=script&lang=js"
export * from "./recentList.vue?vue&type=script&lang=js"
import style0 from "./recentList.vue?vue&type=style&index=0&id=6a3b5095&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3b5095",
  null
  
)

export default component.exports